import 'lazysizes/plugins/rias/ls.rias';
import lazySizes from 'lazysizes';
import debounce from 'lodash.debounce';

lazySizes.cfg.loadHidden = false;

const sizes = [
  30, 60, 90, 120, 150, 180, 210, 240, 270, 300, 330,
  410, 490, 570, 650, 730, 810, 890, 970,
  1050, 1290, 1530, 1770,
  2090, 2410, 2730,
];

document.addEventListener('lazyriasmodifyoptions', (event: CustomEvent) => {
  if (!(event.target instanceof HTMLElement)) {
    return;
  }

  const targets = [{
    width: 0,
    aspect: event.detail.aspectratio,
    element: event.target,
  }];

  if (event.detail.isPicture) {
    const sources = event.target.parentElement.querySelectorAll('source');

    sources.forEach((source) => {
      targets.push({
        width: parseInt(source.media.replace(/\D/g, ''), 10),
        aspect: parseFloat(source.dataset.aspectratio),
        element: source,
      });
    });
  }

  const currentTarget = targets.reverse().find((target) => window.innerWidth >= target.width);
  const width = parseInt(currentTarget.element.dataset.maxWidth, 10);
  const height = parseInt(currentTarget.element.dataset.maxHeight, 10);
  const widths = [];

  sizes.forEach((size) => {
    if (currentTarget.aspect) {
      if (size <= width && size / currentTarget.aspect <= height) {
        widths.push(size);
      }
    } else if (size <= width) {
      widths.push(size);
    }
  });

  event.detail.widths = widths;
});

let currentWidth = window.innerWidth;
const reloadImages = () => {
  if (currentWidth === window.innerWidth) {
    return;
  }

  currentWidth = window.innerWidth;
  const images = document.querySelectorAll(`picture img.${lazySizes.cfg.loadedClass}`);

  images.forEach((image) => {
    image.classList.remove(lazySizes.cfg.loadedClass);
    image.classList.add(lazySizes.cfg.lazyClass);
  });
};

window.addEventListener('resize', debounce(reloadImages, 250));
